// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"295":"519e0b31","701":"f6ffff0a","772":"0641fc58"}[chunkId] + ".css";
};